
import StudentSelectionFlyoutComponent from '@/components/Flyout/StudentSelectionFlyoutComponent.vue';
import PostGainsComponent from '@/components/StudentDashboard/Gains/PostGainsComponent.vue';
import PreGainsComponent from '@/components/StudentDashboard/Gains/PreGainsComponent.vue';
import StudentDutyStatusComponent from '@/components/StudentDashboard/Gains/StudentDutyStatusComponent.vue';
import StudentGroupInfoComponent from '@/components/StudentDashboard/Gains/StudentGroupInfoComponent.vue';
import StudentRecruiterComponent from '@/components/StudentDashboard/Gains/StudentRecruiterComponent.vue';
import StudentVitalsComponent from '@/components/StudentDashboard/Gains/StudentVitalsComponent.vue';
import UpdateStudentMixin from '@/mixins/updateStudentMixin';
import { Student } from '@/models/Entities/Student/Student';
import { Component, Mixins, Vue } from 'vue-property-decorator';
import DutyStatusColumnComponent from '../../StudentDashboard/Gains/DutyStatusColumnComponent.vue';
import EdcsaComponent from '../../StudentDashboard/Gains/EdcsaComponent.vue';
import { GainsFlyoutOptions } from '../FlyoutMounter';

@Component<GainsFlyoutComponent>({
  components: {
    PostGainsComponent,
    PreGainsComponent,
    StudentRecruiterComponent,
    StudentDutyStatusComponent,
    StudentVitalsComponent,
    StudentGroupInfoComponent,
    DutyStatusColumnComponent,
    StudentSelectionFlyoutComponent,
    EdcsaComponent
  }
})
// TODO: check methods are working after students are passed and can render
export default class GainsFlyoutComponent extends Mixins(
  UpdateStudentMixin,
  Vue
) {
  students!: Student[];
  show = false;
  activeStudentIndex = 0;

  resolve: () => void = (): void => void 0;
  reject: () => void = (): void => void 0;

  public open(options?: GainsFlyoutOptions): Promise<void> {
    this.show = true;
    this.students = options?.students ?? [];
    return new Promise((resolve) => {
      this.resolve = resolve;
    });
  }

  close(): void {
    this.show = false;
    this.reject();
  }

  handleSelectStudent(index: number): void {
    this.activeStudentIndex = index;
  }

  get activeStudent(): Student {
    return this.students[this.activeStudentIndex];
  }
}
